module.exports = __webpack_public_path__ + "media/images/banner-1-c53d96a95604a66be404529aaaee1557.jpg";